var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dashboard md-text-center"},[_c('base-icon',{attrs:{"name":"search-user"}}),_c('h1',{staticClass:"dashboard__title"},[_vm._v("Bir Müşteri Arayınız")])],1),_c('div',{staticClass:"dashboard__search-input"},[_c('search-customer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }